import { Box, Flex, Text } from "@chakra-ui/react";
import { ROUTE_NAMES, TOAST_VARIANT } from "@root/constants";
import { useMainChatContext } from "@root/context/kps-chat-context";
import { useNotification } from "@root/hooks/useNotification";
import { useTranslation } from "react-i18next";
import { Card } from "@root/components/common/cards";
import { Sparkle } from "@root/assets/icons/sparkle";
import { BookIcon } from "@root/assets/icons/book";
import { ChartLineIcon } from "@root/assets/icons/chart-line";
import { useLocation } from "react-router-dom";

export const SuggestedQuestionsAndFaqs = ({ onSubmitHandler }: any) => {
  const {
    suggestedQuestionsData,
    faqsData,
    setInput,
    selectedProject,
    attachedFile,
  } = useMainChatContext();
  const { t } = useTranslation("common");
  const { pathname } = useLocation();
  const { showNotification } = useNotification();
  const isMultiDoc = pathname === ROUTE_NAMES.CHECKLIST;
  const isDrawingAnalysis = pathname.startsWith(ROUTE_NAMES.DRAWING_ANALYSIS);
  const isProjectChatbot =
    pathname === ROUTE_NAMES.DOCUMENT_INTEGRATION_CHATBOT;

  const handleQuestionClick = (question: string) => {
    if (isMultiDoc && attachedFile?.length < 1) {
      showNotification({
        type: TOAST_VARIANT.WARNING,
        message: t("dashboard.pleaseSelectDocumentFirst"),
      });
      return;
    }
    if (isDrawingAnalysis && !attachedFile?.length) {
      showNotification({
        type: TOAST_VARIANT.ERROR,
        message: t("upload_document.upload_drawing_file"),
      });
      return;
    }
    setInput(question);
    onSubmitHandler(question);
  };

  // Icons array with their colors
  const icons = [
    { component: <Sparkle />, color: "#B266FF" },
    { component: <BookIcon />, color: "#1DB1C4" },
    { component: <ChartLineIcon />, color: "#E0282F" },
  ];

  // Helper function to get icon by index (rotates through icons)
  const getIcon = (index: number) => {
    return icons?.[index % icons?.length];
  };

  return (
    <Box width="100%" maxW="750px" mx="auto" bgColor={"#f5f5f5"}>
      <Flex gap="20px" flexDir="column">
        {/* Suggested Questions */}
        {suggestedQuestionsData?.rows &&
          suggestedQuestionsData?.rows?.length > 0 && (
            <Box>
              <Text
                fontWeight={600}
                fontSize="16px"
                color="#1A1A1A"
                mb="12px"
                textAlign="left"
              >
                {t("dashboard.suggestedQuestionsHeading")}
              </Text>
              <Flex gap={3} flexWrap="wrap">
                {suggestedQuestionsData?.rows
                  ?.slice(0, 3)
                  ?.map((q: any, idx: number) => {
                    const iconData = getIcon(idx);
                    return (
                      <Box
                        key={`sq-${idx}`}
                        width="230px"
                        height="120px"
                        flexShrink={0}
                      >
                        <Card
                          content={q?.question}
                          icon={iconData?.component}
                          iconColor={iconData?.color}
                          onClick={() => handleQuestionClick(q?.question)}
                        />
                      </Box>
                    );
                  })}
              </Flex>
            </Box>
          )}

        {/* FAQs */}
        {faqsData?.rows && faqsData?.rows?.length > 0 && (
          <Box>
            <Text
              fontWeight={600}
              fontSize="16px"
              color="#1A1A1A"
              mb="12px"
              textAlign="left"
            >
              {t("dashboard.faqHeading")}
            </Text>
            <Flex gap={3} flexWrap="wrap">
              {faqsData?.rows?.slice(0, 3)?.map((q: any, idx: number) => {
                const iconData = getIcon(idx);
                return (
                  <Box
                    key={`faq-${idx}`}
                    width="230px"
                    height="120px"
                    flexShrink={0}
                  >
                    <Card
                      content={q?.question}
                      icon={iconData?.component}
                      iconColor={iconData?.color}
                      onClick={() => handleQuestionClick(q?.question)}
                    />
                  </Box>
                );
              })}
            </Flex>
          </Box>
        )}
      </Flex>
    </Box>
  );
};

export default SuggestedQuestionsAndFaqs;
